/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http from "@/utils/http";
const url = action => `/sync/maillist/${action[0]}`;

export default class MAILLIST {
  static CACHE(params) {
    return http.get(url`cache`, { params });
  }
  static GET_ENTRY_BY_MAIL(params) {
    return http.get(url`getentrybymail`, { params });
  }
}
